<template>
    <!--
        FASE 4 / BLOCO AD — DOC 94: consulta externa de documento assinado, por URL ou QRCode.
        Fora do layout autenticado: quem verifica não precisa ter conta.
    -->
    <div class="pagina-publica">
        <div class="cartao">
            <div v-if="carregando" class="u-text-center">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <template v-else-if="dados">
                <div class="selo" :class="dados.todas_integras ? 'ok' : 'alerta'">
                    <i :class="dados.todas_integras ? 'el-icon-circle-check' : 'el-icon-warning'"></i>
                    <div>
                        <strong v-if="dados.situacao === 'concluido' && dados.todas_integras">
                            Documento assinado e íntegro
                        </strong>
                        <strong v-else-if="dados.situacao === 'concluido'">
                            Atenção: a verificação não foi confirmada
                        </strong>
                        <strong v-else>
                            Procedimento {{ dados.situacao }}
                        </strong>
                        <div class="meta">Conferido em {{ dados.verificado_em }}</div>
                    </div>
                </div>

                <h2>{{ dados.documento }}</h2>
                <div class="meta" v-if="dados.natureza">{{ dados.natureza }}</div>

                <h3>Assinantes</h3>
                <table class="dados">
                    <tr>
                        <th>Nome</th><th>CPF/CNPJ</th><th>Data</th><th>Conferência</th>
                    </tr>
                    <tr v-for="(a, i) in dados.assinantes" :key="i">
                        <td>{{ a.nome || '—' }}</td>
                        <td>{{ a.cpf_cnpj || '—' }}</td>
                        <td>{{ a.assinado_em | formatarData }}</td>
                        <td>
                            <span v-if="a.situacao === 'assinado' && a.integra && a.certificado_coerente"
                                  class="txt-ok">confere</span>
                            <span v-else-if="a.situacao === 'recusado'" class="txt-falha">recusou</span>
                            <span v-else-if="a.situacao === 'assinado'" class="txt-falha">não confere</span>
                            <span v-else class="meta">pendente</span>
                        </td>
                    </tr>
                </table>

                <div class="aviso">
                    <i class="el-icon-info"></i>
                    A conferência é feita neste momento, comparando cada assinatura com o arquivo
                    guardado. Se o documento tiver sido alterado depois de assinado, isto aparece
                    aqui.
                </div>

                <div class="codigo">Código de verificação: {{ dados.codigo }}</div>
            </template>

            <div v-else class="erro">
                <i class="el-icon-warning-outline"></i>
                <p>{{ mensagemErro }}</p>
            </div>
        </div>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        carregando: true,
        dados: null,
        mensagemErro: 'Código inválido ou documento não encontrado.'
    }),
    mounted () {
        const codigo = this.$route.params.codigo

        // Sem cabeçalho de autenticação: a rota é pública por definição do edital.
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/publico/assinatura/verificar/${codigo}`)
            .then(r => { this.dados = r.data; this.carregando = false })
            .catch(e => {
                const d = e && e.response ? e.response.data : null
                if (d && typeof d.erro === 'string') this.mensagemErro = d.erro
                this.carregando = false
            })
    }
}
</script>
<style scoped>
.pagina-publica { min-height: 100vh; background: #F5F7FA; padding: 40px 15px; }
.cartao { max-width: 680px; margin: 0 auto; background: #fff; border-radius: 6px;
          box-shadow: 0 2px 12px rgba(0,0,0,.08); padding: 28px; }
.selo { display: flex; align-items: center; gap: 12px; border: 2px solid #67C23A;
        border-radius: 4px; padding: 12px; margin-bottom: 18px; }
.selo.alerta { border-color: #F56C6C; }
.selo i { font-size: 30px; color: #67C23A; }
.selo.alerta i { color: #F56C6C; }
h2 { margin: 0 0 4px; font-size: 19px; color: #303133; }
h3 { font-size: 14px; margin: 20px 0 8px; }
.meta { color: #909399; font-size: 13px; }
.dados { width: 100%; border-collapse: collapse; }
.dados th, .dados td { border-bottom: 1px solid #EBEEF5; padding: 7px 4px;
                       text-align: left; font-size: 13px; }
.dados th { color: #909399; font-weight: 500; font-size: 12px; }
.txt-ok    { color: #67C23A; font-weight: 600; }
.txt-falha { color: #F56C6C; font-weight: 600; }
.aviso { margin-top: 20px; padding: 12px; background: #F4F4F5; border-radius: 4px;
         font-size: 13px; color: #606266; }
.codigo { margin-top: 14px; font-family: monospace; font-size: 11px; color: #C0C4CC; }
.erro { text-align: center; color: #F56C6C; padding: 30px 0; }
.erro i { font-size: 42px; display: block; margin-bottom: 12px; }
</style>
